import React from 'react';
import ReactDOM from 'react-dom';
import firebase from 'firebase/app';
import './index.css';
import './react-tabs.css';
import './react-datetime.css';
import 'react-table/react-table.css';
import registerServiceWorker from './registerServiceWorker';
import App from './app';

var config = {
  apiKey: "AIzaSyC4ogxRXEYfTPMrZ5u1avdupsmIOxojC-A",
  authDomain: "vexpo-shows.firebaseapp.com",
  databaseURL: "https://vexpo-shows.firebaseio.com",
  projectId: "vexpo-shows",
  storageBucket: "vexpo-shows.appspot.com",
  messagingSenderId: "95835937652"
};
firebase.initializeApp(config);
//firebase.database.enableLogging(true);
window.fb = firebase;

const firestore = firebase.firestore();
const settings = {timestampsInSnapshots: true};
firestore.settings(settings);

ReactDOM.render(<App/>, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js